import { useState } from 'react';
import Button from '../Button/Button';
import './Dialog.scss';

export default function Dialog({ type, message, defaultValue = '', onDismiss }) {
    const [value, setValue] = useState(defaultValue);

    const cancelValue = type === 'confirm' ? false : null;

    return (
        <div className="dialog-overlay" onClick={() => onDismiss(cancelValue)}>
            <div className="dialog-box" onClick={e => e.stopPropagation()}>
                <p className="dialog-message">{message}</p>
                {type === 'prompt' && (
                    <input
                        className="dialog-input"
                        type="text"
                        value={value}
                        onChange={e => setValue(e.target.value)}
                        onKeyDown={e => e.key === 'Enter' && onDismiss(value)}
                        autoFocus
                    />
                )}
                <div className="dialog-actions">
                    {type === 'alert' && (
                        <Button text="OK" onClick={() => onDismiss()} />
                    )}
                    {type === 'confirm' && (
                        <>
                            <Button text="Cancelar" onClick={() => onDismiss(false)} />
                            <Button text="Aceptar" onClick={() => onDismiss(true)} />
                        </>
                    )}
                    {type === 'prompt' && (
                        <>
                            <Button text="Cancelar" onClick={() => onDismiss(null)} />
                            <Button text="Aceptar" onClick={() => onDismiss(value)} />
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}